import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { Batch } from '@types'

import { getBillingBatch } from './api'
import sortBySetter from '../../utils/sort-by-setter'

const onError = () => {
  notification.error({
    message: 'Error al obtener los lotes',
  })
}

const useGetBatchees = () => {
  const { data, isLoading, refetch } = useQuery(QUERY_KEYS.BILLING_BATCH, getBillingBatch, {
    onError,
    refetchOnWindowFocus: false,
  })
  return {
    billingBatch: data ? (data.sort(sortBySetter('id', true)) as Batch[]) : ([] as Batch[]),
    isLoading,
    loadBatchees: refetch,
  }
}

export { useGetBatchees }
